import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../../Utils/atoms';

const PrizePopUp = (props) => {
    const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;

    const handleConfirmClick = () => {
        props.close();
    }

	return (
		<>
            <div className='dim'></div>
            <div className="popup">
                <header>보상받기</header>
                <div className="content">
                    <div className="photo">
                        <img src={`${IMG_URL}/images/bingo/item5_on.png`} alt="아이템" />
                    </div>
                    <div className="name">호감쿠키 {props.rewardCount}개</div>
                </div>
                <div className="btn-area">
                    <button onClick={handleConfirmClick}>
                        <img src={`${IMG_URL}/images/bingo/btn_confirm.png`} alt="확인" />
                    </button>
                </div>
            </div>
		</>
	);
};

export default PrizePopUp;